import React from 'react';
import PropTypes from 'prop-types';

// components
import LayerProvince from '../../../../components/map/Province';

export default function RainfallForecastMap(props) {
  const { datas, currentMode, currentAreaCode } = props;

  let datasFilter = datas;
  if (currentMode === 'province' && currentAreaCode > 0) {
    datasFilter = datas.filter((d) => d.province_code === currentAreaCode);
  }

  const eachLayerData = (data, i) => {
    console.log(data);
    const color = (data.rainforecast_level === 4) ? '#f0ad4e' : '#ff0000';
    return (
      <LayerProvince
        key={i}
        areaType={0}
        areaId={data.province_code}
        areaFill
        areaCurrentFillColor={color}
        areaCurrentFillOpacity={0.9}
        areaCurrentWeight={2}
      />
    );
  };

  return (
    <>
      {datasFilter.map(eachLayerData)}
    </>
  );
}

RainfallForecastMap.defaultProps = {
  currentMode: '',
  currentAreaCode: '',
};

RainfallForecastMap.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  currentMode: PropTypes.string,
  currentAreaCode: PropTypes.string,
};
